import React from "react";
import { Center, Spinner } from "@chakra-ui/react";

const Loader = () => {
  return (
    <Center minH="100vh" w="full" bg="gray.50">
      <Spinner
        thickness="3px"
        speed="0.7s"
        emptyColor="gray.200"
        color="brand.600"
        size="xl"
      />
    </Center>
  );
};

export default Loader;
